module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_vestfold_telemark_pos.4cbf434e.png";